import React from 'react';

function SectionHeader({ title, icon = 'fa-video', showFilterButton = true, onFilterClick }) {
  const headerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px',
    paddingBottom: '12px',
    borderBottom: '2px solid #353535'
  };

  const titleContainerStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
  };

  const iconStyle = {
    fontSize: '1.3em',
    color: '#D7B615'
  };

  const titleStyle = {
    fontSize: '1.2em',
    fontWeight: '500',
    color: 'rgba(255, 255, 255, 0.9)',
    letterSpacing: '0.3px'
  };

  const filterButtonStyle = {
    backgroundColor: 'transparent',
    border: '1px solid #555',
    borderRadius: '8px',
    color: '#D7B615',
    width: '36px',
    height: '36px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'all 0.2s ease'
  };

  return (
    <div style={headerStyle}>
      <div style={titleContainerStyle}>
        <i className={`fas ${icon}`} style={iconStyle}></i>
        <span style={titleStyle}>{title}</span>
      </div>
      {showFilterButton && (
        <button
          style={filterButtonStyle}
          onClick={onFilterClick}
          onMouseEnter={(e) => {
            e.currentTarget.style.borderColor = '#D7B615';
            e.currentTarget.style.backgroundColor = 'rgba(215, 182, 21, 0.1)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.borderColor = '#555';
            e.currentTarget.style.backgroundColor = 'transparent';
          }}
        >
          <i className="fas fa-sliders-h"></i>
        </button>
      )}
    </div>
  );
}

export default SectionHeader; 